module.exports = __webpack_public_path__ + "static/img/slaflow1.ffc0597.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/slaflow1.png
// module id = jxvN
// module chunks = 2